import { StyleSheet, View } from 'react-native';

import { Text } from '@/components/Text';
import { colors, radii, spacing } from '@/constants/theme';
import type { VideoAdStats as Stats } from '@/types/voltr';

export type VideoAdStatsProps = {
  stats: Stats;
  testID?: string;
};

/**
 * Under a video a brand runs as an ad: the server's title, its label/value
 * lines (impressions, CTR, spend, revenue, ROAS) in a two-column grid, and its
 * note that ad revenue isn't the athlete's pay. Every word and number is the
 * server's.
 */
export function VideoAdStats({ stats, testID }: VideoAdStatsProps) {
  return (
    <View style={styles.box} testID={testID}>
      <View style={styles.head}>
        <Text variant="captionBold" color="deepGreen">
          {stats.title}
        </Text>
        {stats.updated ? (
          <Text variant="caption" color="textMuted">
            {stats.updated}
          </Text>
        ) : null}
      </View>
      <View style={styles.grid}>
        {stats.lines.map((line) => (
          <View key={line.label} style={styles.cell} accessible accessibilityLabel={`${line.label}: ${line.value}`}>
            <Text variant="bodyBold" color="deepGreen">
              {line.value}
            </Text>
            <Text variant="caption" color="textMuted">
              {line.label}
            </Text>
          </View>
        ))}
      </View>
      {stats.note ? (
        <Text variant="caption" color="textMuted">
          {stats.note}
        </Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    gap: spacing.sm,
    padding: spacing.md,
    borderRadius: radii.base,
    backgroundColor: colors.surfaceSunken,
  },
  head: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline', gap: spacing.sm },
  grid: { flexDirection: 'row', flexWrap: 'wrap', rowGap: spacing.sm },
  // Two to a row.
  cell: { width: '50%', gap: 0 },
});
